import React, { useState, useEffect } from 'react';
import { Mail, Phone } from 'lucide-react';
import { settingsAPI } from '../services/api';

export default function Footer() {
  const [contactInfo, setContactInfo] = useState({
    title: 'Contact Us',
    email: 'adminnutrimus@gmail.com',
    phone: '+62 813-6143-9700',
    disclaimer: 'This tools is intended for use only by Clinical Nutrition Specialists or under their supervision. Clinical decisions must be made by medical professionals.',
    copyright: '© 2026 Nutrimus. All rights reserved.'
  });

  useEffect(() => {
    let isMounted = true;
    const loadSettings = async () => {
      try {
        const data = await settingsAPI.getPublicSettings();
        if (isMounted && data) {
          setContactInfo({
            title: data.contact_title || 'Contact Us',
            email: data.contact_email || 'adminnutrimus@gmail.com',
            phone: data.contact_phone || '+62 813-6143-9700',
            disclaimer: data.contact_disclaimer || 'This tools is intended for use only by Clinical Nutrition Specialists or under their supervision. Clinical decisions must be made by medical professionals.',
            copyright: data.contact_copyright || '© 2026 Nutrimus. All rights reserved.'
          });
        }
      } catch (err) {
        // Silently use defaults
      }
    };
    loadSettings();
    return () => { isMounted = false; };
  }, []);

  return (
    <footer className="bg-white border-t border-slate-200/80 text-slate-600 mt-auto shadow-xs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Contact Information */}
        <div className="mb-4">
          <h4 className="font-bold text-xs uppercase tracking-wider text-slate-400 mb-2.5">
            {contactInfo.title}
          </h4>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-2 text-xs sm:text-sm">
            {contactInfo.email && (
              <div className="flex items-center">
                <div className="p-1.5 rounded-lg bg-emerald-50 text-emerald-600 mr-2 flex-shrink-0">
                  <Mail className="h-3.5 w-3.5" />
                </div>
                <a 
                  href={`mailto:${contactInfo.email}`} 
                  className="font-medium text-slate-700 hover:text-emerald-600 transition-colors"
                >
                  {contactInfo.email}
                </a>
              </div>
            )}
            {contactInfo.phone && (
              <div className="flex items-center">
                <div className="p-1.5 rounded-lg bg-emerald-50 text-emerald-600 mr-2 flex-shrink-0">
                  <Phone className="h-3.5 w-3.5" />
                </div>
                <a 
                  href={`tel:${contactInfo.phone.replace(/[^0-9+]/g, '')}`} 
                  className="font-medium text-slate-700 hover:text-emerald-600 transition-colors"
                >
                  {contactInfo.phone}
                </a>
              </div>
            )}
          </div>
        </div>

        {/* Medical Disclaimer */}
        {contactInfo.disclaimer && (
          <div className="bg-emerald-50/70 border border-emerald-100/80 rounded-xl p-3.5 mb-4">
            <p className="text-xs text-emerald-950 leading-relaxed">
              <span className="font-semibold text-emerald-800">Medical Disclaimer:</span> {contactInfo.disclaimer.replace(/^Medical Disclaimer:\s*/i, '')}
            </p>
          </div>
        )}

        {/* Copyright */}
        <div className="pt-3 border-t border-slate-100 text-center">
          <p className="text-xs text-slate-400">
            {contactInfo.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}

